import { make } from "vuex-pathify"

const state = {
  // UI state
  showNavbar: true,
  showFooter: true,
  showEmploymentForm: false,
  showBookForm: true,
  showPaperForm: true,
  showResearchForm: true,
  showConsultingForm: true,
  isPostPhD: true,
  
  // Data arrays
  employmentPostPhD: [],
  employmentPrePhD: [],
  books: [],
  papers: [],
  research: [],
  consulting: [],
  awards: [],
  
  // Data objects
  bachelors: {},
  masters: {},
  application: {},
  contact: {},
  thesis: {},
  personal: {},
  referee1: {},
  referee2: {},
  
  // File uploads - consolidated into certificates object
  certificates: {
    caste_file_name: null,
    cv: null,
    covering_letter: null,
    job_market_paper: null,
    teaching_statements: null,
    bachelor_degree_certificate: null
  },
  
  // Certificates validation status
  certificates_valid: false,
  
  // Edit state
  editCtr: 0,
  editID: null,
  
  // Data version for migrations
  dataVersion: 1
}

// automatically generate operations
const getters = { 
  ...make.getters(state),
  
  // Additional computed getters
  hasEmploymentData: state => state.employmentPostPhD.length > 0 || state.employmentPrePhD.length > 0,
  hasEducationData: state => Object.keys(state.bachelors).length > 0 || Object.keys(state.masters).length > 0,
  hasResearchData: state => state.research.length > 0,
  hasPapersData: state => state.papers.length > 0,
  hasBooksData: state => state.books.length > 0,
  hasConsultingData: state => state.consulting.length > 0,
  hasAwardsData: state => state.awards.length > 0,
  
  // Progress calculation
  formProgress: state => {
    let completed = 0
    let total = 8 // Total number of main sections
    
    if (state.personal && Object.keys(state.personal).length > 0) completed++
    if (state.contact && Object.keys(state.contact).length > 0) completed++
    if (state.application && Object.keys(state.application).length > 0) completed++
    if (state.bachelors && Object.keys(state.bachelors).length > 0) completed++
    if (state.masters && Object.keys(state.masters).length > 0) completed++
    if (state.employmentPostPhD.length > 0 || state.employmentPrePhD.length > 0) completed++
    if (state.papers.length > 0) completed++
    if (state.research.length > 0) completed++
    
    return Math.round((completed / total) * 100)
  }
}

const mutations = {
  ...make.mutations(state),

  // setting the store back to it's initial state 
  reset(s) {
    Object.assign(s, state)
  }
}

const actions = { 
  ...make.actions(state),
  
  // Additional actions for better UX
  showEmploymentForm({ commit }) {
    commit('setShowEmploymentForm', true)
  },
  
  hideEmploymentForm({ commit }) {
    commit('setShowEmploymentForm', false)
  },
  
  showBookForm({ commit }) {
    commit('setShowBookForm', true)
  },
  
  hideBookForm({ commit }) {
    commit('setShowBookForm', false)
  },
  
  showPaperForm({ commit }) {
    commit('setShowPaperForm', true)
  },
  
  hidePaperForm({ commit }) {
    commit('setShowPaperForm', false)
  },
  
  showResearchForm({ commit }) {
    commit('setShowResearchForm', true)
  },
  
  hideResearchForm({ commit }) {
    commit('setShowResearchForm', false)
  },
  
  showConsultingForm({ commit }) {
    commit('setShowConsultingForm', true)
  },
  
  hideConsultingForm({ commit }) {
    commit('setShowConsultingForm', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
